import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/material-icons';

import { createTheme } from '@mui/material/styles';

const borderRadius = 10;
const pageBackgroundColor = '#f8f8f8';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      dark: '#0076a7',
      main: '#009ACD',
      light: '#CCEBF5',
      contrastText: '#ffffff',
    },
    secondary: {
      dark: '#7e7f80',
      main: '#D7D7D7',
      light: '#EAEBEC',
      contrastText: '#000000',
    },
    tertiary: {
      main: '#000000',
      contrastText: '#ffffff',
    },
    success: {
      main: '#2E7D32',
      light: '#4CAF50',
      dark: '#1B5E20',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
      content: pageBackgroundColor,
    },
  },
  shape: {
    borderRadius,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        body {
          background: ${pageBackgroundColor};
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0; 
        }
        input[type=number] {
            -moz-appearance:textfield;
        }

        pre {
          white-space: pre-wrap;       /* Since CSS 2.1 */
          white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
          white-space: -pre-wrap;      /* Opera 4-6 */
          white-space: -o-pre-wrap;    /* Opera 7 */
          word-wrap: break-word;       /* Internet Explorer 5.5+ */
      }

        .MuiInputBase-root {
          background: #ffffff;
        }
        .MuiFormControl-root .MuiFormLabel-root{
          transform: none;
          position: static;
          margin-bottom: 8px;
        }
        .MuiFormLabel-root{
          font-weight: 500 !important;
          font-size: 0.87rem !important;
        }
        .MuiFormControl-root legend span{
          display: none;
        }
        .MuiFormControl-root .MuiFormHelperText-root.Mui-error{
          font-size: 0.85rem;
        }
        .Mui-datepicker .MuiFormControl-root fieldset{
          top:0 !important;
        }
        .MuiInputBase-root.MuiInputBase-adornedStart{
          padding-left: 6px;
        }
        .MuiInputAdornment-root.MuiInputAdornment-positionStart{
          margin-right: 3px;
        }
        .MuiButton-startIcon{
          margin-right: 2px !important;
        }
        .MuiButton-startIcon svg{
          width:0.8em;
        }
        .MuiButtonBase-root.MuiTab-root{
          text-transform: none;
        }
        .MuiOutlinedInput-root.Mui-disabled{
          opacity:0.5;
        }
        .mapboxgl-ctrl{
          pointer-events: auto;
          margin: 5px;
        }
        
        /* Target the Mapbox Draw control container */
        .mapboxgl-ctrl.mapboxgl-ctrl-group {
          padding: 2px;
          background-color: #fff; 
          border-radius: 8px;
          box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
        }

        /* Style the buttons */
        .mapbox-gl-draw_ctrl-draw-btn {
          width: 35px;
          height: 35px;
          border-radius: 8px;
          border: none;
          background-color: #ffffff; /* light gray, MUI default */
          color: #2563eb; /* primary color */
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background-color 0.2s ease;
        }

        .mapbox-gl-draw_ctrl-draw-btn:hover {
          background-color: #e0e7ff; /* light blue hover */
        }

        /* Optional: icon scaling */
        .mapbox-gl-draw_ctrl-draw-btn svg {
          width: 20px;
          height: 20px;
        .MuiBox-root.Mui-TableHeadCell-Content-Labels{
          align-items: flex-start;
        }
        .MuiBox-root.Mui-TableHeadCell-Content-Labels > .MuiBadge-root{
        margin-top: 3px;
        }
        .MuiTablePagination-root.MuiBox-root{
          padding: 10px 0 0 0;
        }
      `,
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-sizeSmall': {
            height: '34px', // or adjust minHeight if needed
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        inputSizeSmall: {
          padding: '0px 8px', // tighter padding
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          '&.MuiTableCell-head.MuiTableCell-sizeMedium': {
            padding: '3px',
          },
          '&.MuiTableCell-sizeMedium': {
            padding: '10px',
          },
          '&.MuiTableCell-root.MuiTableCell-alignLeft': {
            paddingLeft: '3px',
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          '&.MuiAccordionDetails-root': {
            marginTop: '0px',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: '0.875rem',
          color: '#424443',
          '&.Mui-disabled': {
            opacity: 1,
            color: '#424443',
          },
          '&.Mui-error': {
            color: theme.palette.error.main,
          },
        }),
      },
    },
  },
});

export const darkTheme = createTheme({
  ...lightTheme,
});
